import { faCircleInfo } from "@fortawesome/pro-light-svg-icons/faCircleInfo";
import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons/faGripDotsVertical";
import { faLinkSimple } from "@fortawesome/pro-light-svg-icons/faLinkSimple";
import { faGripLines } from "@fortawesome/pro-light-svg-icons/faGripLines";
import { faClipboard } from "@fortawesome/pro-light-svg-icons/faClipboard";
import { faDownload } from "@fortawesome/pro-light-svg-icons/faDownload";
import { faUpload } from "@fortawesome/pro-light-svg-icons/faUpload";
import { faPen } from "@fortawesome/pro-light-svg-icons/faPen";
import { faCode } from "@fortawesome/pro-light-svg-icons/faCode";
import { faSortNumericDown } from "@fortawesome/pro-light-svg-icons/faSortNumericDown";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons/faExclamationCircle";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons/faCheckCircle";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faChevronDoubleRight } from "@fortawesome/pro-light-svg-icons/faChevronDoubleRight";
import { faTrophy } from "@fortawesome/pro-light-svg-icons/faTrophy";
import { faCog } from "@fortawesome/pro-light-svg-icons/faCog";
import { faSignOut } from "@fortawesome/pro-light-svg-icons/faSignOut";
import { faFileSpreadsheet } from "@fortawesome/pro-light-svg-icons/faFileSpreadsheet";
import { faUserSlash } from "@fortawesome/pro-light-svg-icons/faUserSlash";
import { faKey } from "@fortawesome/pro-light-svg-icons/faKey";
import { faEllipsisVAlt } from "@fortawesome/pro-light-svg-icons/faEllipsisVAlt";
import { faFileExport } from "@fortawesome/pro-light-svg-icons/faFileExport";
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faCreditCard } from "@fortawesome/pro-light-svg-icons/faCreditCard";
import { faFile } from "@fortawesome/pro-light-svg-icons/faFile";
import { faUser } from "@fortawesome/pro-light-svg-icons/faUser";
import { faStar } from "@fortawesome/pro-light-svg-icons/faStar";
import { faPlayCircle } from "@fortawesome/pro-light-svg-icons/faPlayCircle";
import { faHeadset } from "@fortawesome/pro-light-svg-icons/faHeadset";
import { faDatabase } from "@fortawesome/pro-light-svg-icons/faDatabase";
import { faFileCsv } from "@fortawesome/pro-light-svg-icons/faFileCsv";
import { faPaperPlane } from "@fortawesome/pro-light-svg-icons/faPaperPlane";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons/faQuestionCircle";
import { faExchangeAlt } from "@fortawesome/pro-light-svg-icons/faExchangeAlt";
import { faGlobe } from "@fortawesome/pro-light-svg-icons/faGlobe";
import { faLink } from "@fortawesome/pro-light-svg-icons/faLink";
import { faUnderline } from "@fortawesome/pro-light-svg-icons/faUnderline";
import { faItalic } from "@fortawesome/pro-light-svg-icons/faItalic";
import { faBold } from "@fortawesome/pro-light-svg-icons/faBold";
import { faEyeSlash } from "@fortawesome/pro-light-svg-icons/faEyeSlash";
import { faEye } from "@fortawesome/pro-light-svg-icons/faEye";
import { faHistory } from "@fortawesome/pro-light-svg-icons/faHistory";
import { faAlignJustify } from "@fortawesome/pro-light-svg-icons/faAlignJustify";
import { faColumns } from "@fortawesome/pro-light-svg-icons/faColumns";
import { faTh } from "@fortawesome/pro-light-svg-icons/faTh";
import { faSyncAlt } from "@fortawesome/pro-light-svg-icons/faSyncAlt";
import { faAtlas } from "@fortawesome/pro-light-svg-icons/faAtlas";
import { faBook } from "@fortawesome/pro-light-svg-icons/faBook";
import { faCalculator } from "@fortawesome/pro-light-svg-icons/faCalculator";
import { faTrash } from "@fortawesome/pro-light-svg-icons/faTrash";
import { faFileUpload } from "@fortawesome/pro-light-svg-icons/faFileUpload";
import { faSearch } from "@fortawesome/pro-light-svg-icons/faSearch";
import { faPlus } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faCircleNotch } from "@fortawesome/pro-light-svg-icons/faCircleNotch";
import { faSpinner } from "@fortawesome/pro-light-svg-icons/faSpinner";
import { faRandom } from "@fortawesome/pro-light-svg-icons/faRandom";
import { faCaretDown } from "@fortawesome/pro-light-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/pro-light-svg-icons/faCaretUp";
import { faFileAlt } from "@fortawesome/pro-light-svg-icons/faFileAlt";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons/faTimesCircle";
import { faSave } from "@fortawesome/pro-light-svg-icons/faSave";
import { faChartPie } from "@fortawesome/pro-light-svg-icons/faChartPie";
import { faChartBar } from "@fortawesome/pro-light-svg-icons/faChartBar";
import { faUndo } from "@fortawesome/pro-light-svg-icons/faUndo";
import { faLevelUpAlt } from "@fortawesome/pro-light-svg-icons/faLevelUpAlt";
import { faArrowUpFromSquare } from "@fortawesome/pro-light-svg-icons/faArrowUpFromSquare";
import { faCircleSmall } from "@fortawesome/pro-light-svg-icons/faCircleSmall";
import { faCircle } from "@fortawesome/pro-light-svg-icons/faCircle";
import { faClone } from "@fortawesome/pro-light-svg-icons/faClone";
import { faQuestion } from "@fortawesome/pro-light-svg-icons/faQuestion";
import { faCircleP } from "@fortawesome/pro-light-svg-icons/faCircleP";
import { faParagraph } from "@fortawesome/pro-light-svg-icons/faParagraph";
import { faMoonStars } from "@fortawesome/pro-light-svg-icons/faMoonStars";
import { faBolt } from "@fortawesome/pro-light-svg-icons/faBolt";
import { faWandMagicSparkles } from "@fortawesome/pro-light-svg-icons/faWandMagicSparkles";
import { faCircle1 } from "@fortawesome/pro-light-svg-icons/faCircle1";
import { faCircle2 } from "@fortawesome/pro-light-svg-icons/faCircle2";
import { faCircle3 } from "@fortawesome/pro-light-svg-icons/faCircle3";
import { faIslandTropical } from "@fortawesome/pro-light-svg-icons/faIslandTropical";
import { faUmbrellaBeach } from "@fortawesome/pro-light-svg-icons/faUmbrellaBeach";
import { faRocketLaunch } from "@fortawesome/pro-light-svg-icons/faRocketLaunch";
import { faFilter } from "@fortawesome/pro-light-svg-icons/faFilter";
import { faBars } from "@fortawesome/pro-light-svg-icons/faBars";
import { faWebhook } from "@fortawesome/pro-light-svg-icons/faWebhook";
import { faLanguage } from "@fortawesome/pro-light-svg-icons/faLanguage";
export default {
  faTrash,
  faFileUpload,
  faSearch,
  faPlus,
  faTimes,
  faCircleNotch,
  faSpinner,
  faRandom,
  faCaretDown,
  faCaretUp,
  faFileAlt,
  faTimesCircle,
  faSave,
  faChartPie,
  faChartBar,
  faUndo,
  faLevelUpAlt,
  faCalculator,
  faBook,
  faAtlas,
  faSyncAlt,
  faTh,
  faColumns,
  faAlignJustify,
  faHistory,
  faEye,
  faEyeSlash,
  faBold,
  faItalic,
  faUnderline,
  faLink,
  faGlobe,
  faExchangeAlt,
  faQuestionCircle,
  faPaperPlane,
  faFileCsv,
  faDatabase,
  faHeadset,
  faPlayCircle,
  faStar,
  faUser,
  faFile,
  faCreditCard,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faFileExport,
  faEllipsisVAlt,
  faKey,
  faUserSlash,
  faFileSpreadsheet,
  faSignOut,
  faCog,
  faTrophy,
  faChevronDoubleRight,
  faCheck,
  faCheckCircle,
  faExclamationCircle,
  faSortNumericDown,
  faCode,
  faPen,
  faDownload,
  faUpload,
  faClipboard,
  faGripLines,
  faLinkSimple,
  faGripDotsVertical,
  faCircleInfo,
  faArrowUpFromSquare,
  faCircleSmall,
  faCircle,
  faClone,
  faQuestion,
  faCircleP,
  faParagraph,
  faMoonStars,
  faBolt,
  faWandMagicSparkles,
  faCircle1,
  faCircle2,
  faCircle3,
  faIslandTropical,
  faUmbrellaBeach,
  faRocketLaunch,
  faFilter,
  faBars,
  faWebhook,
  faLanguage
};
